import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=b54e566e&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b54e566e')) {
      api.createRecord('b54e566e', component.options)
    } else {
      api.reload('b54e566e', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=b54e566e&", function () {
      api.rerender('b54e566e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GhxtgWr5BMSO/JS/comp/seasonprices.vue"
export default component.exports